import styled from "styled-components";
import { breakpoints, colors } from "src/variables";

export const Button = styled.a`
  border: 1px solid ${colors.magenta};
  color: ${colors.magenta};
  font-size: 18px;
  text-decoration: none;
  max-width: 136px;
  font-family: "TeleNeo";
  font-weight: 700;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 26px;
  padding: 1rem 0px;
  text-transform: uppercase;

  &:hover {
    color: ${colors.white};
    background-color: ${colors.magenta};
  }

  @media screen and (max-width: ${breakpoints.tabletLandscape}px) {
    font-size: 14px;
  }

  @media screen and (max-width: ${breakpoints.tabletPortrait}px) {
    max-width: 105px;
    padding: 12px 0;
  }
`;

export const LoadMore = styled(Button)`
  font-family: TeleNeo;
  font-weight: 700;
  text-transform: capitalize;
  padding: 1rem;
  cursor: pointer;
  margin-top: 10px;
  max-width: unset;
  margin: 1.5rem;
  @media screen and (max-width: ${breakpoints.tabletPortrait}px) {
    padding: 0.5rem;
  }
`;

export const Flex = styled.div`
  display: flex;
`;
